import { SVGProps, Ref, forwardRef } from 'react'
const SvgSavingBank = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 20 21"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      clipPath="url(#SavingBank_svg__a)"
    >
      <path d="M1.25 20.065h17.5M18.75 7.566H1.25l8.074-4.802a1.25 1.25 0 0 1 1.352 0l8.074 4.802ZM17.5 10.065v7.5H15v-7.5M11.25 10.065v7.5h-2.5v-7.5M5 10.065v7.5H2.5v-7.5" />
    </g>
    <defs>
      <clipPath id="SavingBank_svg__a">
        <path fill="#fff" d="M0 0h20v20H0z" transform="translate(0 .69)" />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgSavingBank)
export default ForwardRef
